var React = require('react');

function CarouselLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 6.30355e-08L21 5.12187L9.6 16.5L21 27.8781L16 33L2.03375e-06 16.5L16 6.30355e-08Z"}));
}

CarouselLeft.defaultProps = {"width":"21","height":"33","viewBox":"0 0 21 33","fill":"none"};

module.exports = CarouselLeft;

CarouselLeft.default = CarouselLeft;
